
import React, { useState, useEffect } from 'react';
import Button from '../../components/ui/Button';
import InputWithIcon from '../../components/ui/InputWithIcon';
import api from '../../api/api';

const PurOrderHeader = ({
  orderDetails,
  user,
  setSuccess,
  setError,
  setOrderDetails,
}) => {
  const [editableAddress, setEditableAddress] = useState('');
  const [loading, setLoading] = useState(false);
  const [orderDate, setOrderDate] = useState('');

  // Format date to yyyy-MM-dd for input
  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const d = new Date(dateString);
    if (isNaN(d.getTime())) return '';
    return d.toISOString().split('T')[0];
  };

  // Format date to yyyy-MM-ddTHH:mm:ss for API
  const formatDateForApi = (dateString) => {
    if (!dateString) return null;
    return `${dateString}T00:00:00`;
  };

  // Load initial values
  useEffect(() => {
    if (orderDetails) {
      setEditableAddress(orderDetails.Address || '');
      setOrderDate(formatDateForInput(orderDetails.Podate));
    }
  }, [orderDetails]);

const handleUpdateOrder = async (e) => {
  if (e) e.preventDefault();
  setLoading(true);
  setError('');
  setSuccess('');

  try {
    await api.updatepurOrderDetails({
      // ✅ use correct case (Poid not POId)
      Poid: orderDetails?.Poid || orderDetails?.POId,  
      Address: editableAddress,
      MobileNo: orderDetails?.MobileNo || '',
      Deliverydate: orderDate ? `${orderDate}T00:00:00` : null, // ✅ only one T00:00:00
      User: user?.UsrName || '',
      amountPaid: 0,   // or from state if you add UI
      Paymode: 'cash', // or from state if you add UI
      Refno: ''        // or from state if you add UI
    });

    if (setOrderDetails) {
      setOrderDetails((prev) => ({
        ...prev,
        Address: editableAddress,
        Podate: orderDate
      }));
    }

    setSuccess('Order details updated successfully!');
    setTimeout(() => setSuccess(''), 3000);
  } catch (err) {
    console.error("Update Order Error:", err);
    setError('Failed to update order.');
  } finally {
    setLoading(false);
  }
};


  return (
    <div className="w-full max-w-4xl mx-auto bg-white shadow-lg rounded-xl p-6">
      <h2 className="text-lg sm:text-xl font-bold mb-4 text-center">
        Customer & Order Info
      </h2>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        {/* Left Column */}
        <div className="space-y-4">
          <InputWithIcon
            label="Customer Name"
            id="customerName"
            value={orderDetails?.Vname || ''}
            readOnly
          />

          <div>
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Address
            </label>
            <textarea
              value={editableAddress}
              onChange={(e) => setEditableAddress(e.target.value)}
              rows="3"
              className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>

        {/* Right Column */}
        <div className="space-y-4">
          <InputWithIcon
            label="Mobile"
            id="mobile"
            value={orderDetails?.MobileNo || ''}
            readOnly
          />

          <InputWithIcon
            label="Balance"
            id="balance"
            value={(orderDetails?.Balance || 0).toLocaleString('en-IN', {
              style: 'currency',
              currency: 'INR',
            })}
            readOnly
          />

          <div>
            <label className="block mb-2 text-sm font-bold text-gray-700">
              Order Date
            </label>
            <input
              type="date"
              value={orderDate}
              onChange={(e) => setOrderDate(e.target.value)}
              className="w-full p-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>
        </div>
      </div>

      {/* Buttons */}
      <div className="flex justify-end gap-3 mt-6">
        <Button
          type="button"
          onClick={handleUpdateOrder}
          disabled={loading}
          className="px-4 py-2"
        >
          {loading ? 'Updating...' : 'Update Order Details'}
        </Button>
      </div>
    </div>
  );
};

export default PurOrderHeader;
